import request from '@/plugin/axios'

// 注册
export function register(data) {
  return request({
    url: '/com/register',
    method: 'post',
    data
  })
}

// 获取验证码
export function sendCode(phone) {
  return request({
    url: '/com/sendCode',
    method: 'get',
    params: { phone }
  })
}

export function checkVersion(version = '0.0.0') {
  return request({
    url: '/com/download',
    method: 'get',
    params: { version }
  })
}

// 获取店铺价格
export const getShopPrices = (data = {}) => request({
  url: '/project/jbpVipPlans/plansList',
  method: 'post',
  data: data
})

//获取帮助中心
export const getHelpCenter = (data = {}) => request({
  url: '/project/JbpArticle/getHelpCenter',
  method: 'get',
  params: data
})

// 提交反馈
export const submitFeedback = (data) => request({
  url: '/com/feedback',
  method: 'post',
  data: data
})



